import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../api'
import { Link } from 'lucide-react';
import { useAuth } from '../Context/AuthContext'
import ThemeChanger from '../Components/ThemeChanger'
import RoadMapLoader from '../Components/Loaders/RoadMapPageLoader';

export default function RoadMapPage() {
    const { roadMapId } = useParams();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(null)
    const [roadMapTopic, setRoadMapTopic] = useState('');
    const [roadMapSubtopic, setRoadMapSubtopic] = useState('');
    const [roadmapData, setRoadmapData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [progressPercentage, setProgressPercentage] = useState(0);
    const {auth} = useAuth()
    const [currentItemIndex, setCurrentItemIndex] = useState(null);
    
    useEffect(() => {
        if(!auth.role || !auth.id){
            navigate('/login')
        }
    },[])
    
    const fetchRoadMapData = async(data) => {
        setLoader(true);
        api.get("/user/get-roadmapcards?roadMapId=" + roadMapId).then((res) => {
            const response = res.data;
            const totalCard = response.data.cards.length;
            let completedCards = 0;
            response.data.cards.forEach(element => {
                if(element.status === "complete"){
                    completedCards++;
                }
            })
            setProgressPercentage(Math.round((completedCards / totalCard) * 100));
            if(response.statusCode == 200){
                setLoader(false)
                const responseData = response.data
                setRoadMapTopic(responseData.topicName)
                setRoadMapSubtopic(responseData.subTopicName)
                setRoadmapData(responseData.cards || [])
            }
        })
    }
    useEffect(() => {
        // Load roadmap data based on the ID from URL params
        if(!roadMapId) return
        fetchRoadMapData({roadMapId: roadMapId})
    }, [roadMapId]);
    
    const handlePageClose = () => {
        navigate("/dashboard");
    };
    
    
    const handleMoreInfoClick = (index) => {
        setCurrentItemIndex(index);
        setIsModalOpen(true);
    };
    
    // Handler for updating item status
    const updateStatus = (itemId) => {
        api.put("/user/update-roadmapcard-status", {
            roadMapId: roadMapId,
            cardId: itemId
        }).then((res) => {
            const response = res.data;
            if(response.statusCode == 200){
                setRoadmapData((prevState) => {
                    return prevState.map((card) => {
                        if(card._id === itemId){
                            card.status = card.status === "complete" ? "incomplete" : "complete"
                        }
                        return card
                    })
                })
            }else{
                navigate("/dashboard")
            }
        })
        
    };
    useEffect(() => {
        if(!roadmapData) return;
        const totalCard = roadmapData.length;
        let completedCards = 0;
        roadmapData.forEach(element => {
            if(element.status === "complete"){
                completedCards++;
            }
        })
        setProgressPercentage(Math.round((completedCards / totalCard) * 100));
    },[roadmapData])
    // Close modal handler
    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentItemIndex(null);
    };
    
    if(loader){
        return(
            <RoadMapLoader />
        )
    }
    return (
        <div className="w-full max-w-4xl mx-auto p-8 custom-FontFamily relative">
            <button
                className="btn btn-outline btn-accent fixed top-4 left-5 z-[11] border border-solid border-1"
                onClick={handlePageClose}
            >
                Back
            </button>
            <div className=" fixed top-4 right-5 z-[11] p-4">
                <ThemeChanger />
            </div>
            <div className="bg-base-200 rounded-xl p-8 shadow-xl border border-1 border-neutral relative">
                {/* Header with Topic and Subtopic */}
                <div className="mb-5 text-center">
                    <div className="flex flex-col justify-center items-center">
                        <div className="text-2xl mb-2 font-bold" style={{textTransform:'capitalize'}}>{roadMapTopic}</div>
                        <div className=" text-xl font-bold" style={{textTransform:'capitalize'}}>{roadMapSubtopic}</div>
                    </div>
                </div>
                <div
                    className="w-full sticky top-0 z-50 bg-base-200 p-6 shadow-sm border border-neutral mb-10 rounded-lg"
                >
                    <div className="flex justify-between mb-1 text-sm">
                        <span>Progress</span>
                    </div>
                    <div className="w-full bg-base-300 rounded-full h-2.5">
                        <div
                        className="bg-primary h-2.5 rounded-full transition-all duration-700 ease-in-out"
                        style={{ width: `${progressPercentage}%` }}
                        ></div>
                    </div>
                </div>
                <div className="hidden md:block absolute left-1/2 top-48 bottom-20 w-1 bg-base-content/20 -translate-x-1/2 z-0 border border-white bg-white"></div>
                
                <div className="relative z-10">
                    {roadmapData.map((item, index) => (
                        <div key={index} className="mb-16 relative">
                            <div className={`flex flex-col md:flex-row items-start md:items-center gap-4 ${index % 2 === 1 ? "md:flex-row-reverse" : ""}`}>
                                
                                <div className="w-full md:w-5/12 group">
                                    <div className={`backdrop-blur rounded-lg p-5 transition-all duration-300 ${
                                        item.status === "complete" ? "bg-success/10 border-2 border-success hover:bg-success/20" :
                                            "bg-base-100 border border-base-300 hover:bg-base-200"
                                    }`}>
                                        <div className="flex justify-between items-start mb-3">
                                            <h3 className={`text-xl font-semibold ${
                                                item.status === "complete" ? "text-success" : "text-base-content"
                                            }`}>
                                                {item.topic}
                                            </h3>
                                            <span className={`rounded px-2 py-1 text-center ${
                                                item.status === "complete" ? "badge-success text-success-content font-bold" : "badge-ghost"
                                            }`}>
                        {index + 1}
                      </span>
                                        </div>
                                        <p className={`text-sm mb-4 ${
                                            item.status === "complete" ? "text-success/80" : "text-base-content/70"
                                        }`}>
                                            {item.description}
                                        </p>
                                        
                                        <div className="flex gap-4 flex-col lg:flex-row flex-wrap justify-center items-center">
                                            <button
                                                onClick={() => updateStatus(item._id)}
                                                className={`btn btn-sm ${
                                                    item.status === "complete" ? "btn-success text-success-content" : "btn-primary"
                                                }`}
                                            >
                                                {item.status === "complete" ? "Mark as Incompleted" : "Mark as Completed"}
                                            </button>
                                            
                                            <button
                                                className="btn btn-sm btn-ghost"
                                                onClick={() => handleMoreInfoClick(index)}
                                            >
                                                More Info
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="md:absolute left-1/2 -translate-x-1/2 hidden md:flex">
                                    <div className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${
                                        item.status === "complete" ?
                                            "bg-success text-success-content ring-4 ring-success/30" :
                                            "bg-base-300 text-base-content ring-2 ring-base-content/20"
                                    }`}>
                                        {item.status === "complete" ? (
                                            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <polyline points="20 6 9 17 4 12" />
                                            </svg>
                                        ) : (
                                            <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            
            {isModalOpen && currentItemIndex !== null && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-base-100 p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                        <h3 className="text-2xl font-bold mb-4">{roadmapData[currentItemIndex].topic}</h3>
                        <p className="mb-6">{roadmapData[currentItemIndex].description}</p>
                        {/*need to change this*/}
                        <div className="mb-6">
                            <h4 className="font-semibold mb-2">Resources:</h4>
                            <ul className="list-disc pl-5 space-y-2">
                                {
                                    roadmapData[currentItemIndex].links.map(item => (
                                        <li>{item.title}: <a className="text-primary font-bold" href={item.link} target="_blank">Link to Reasource</a></li>
                                    ))
                                }
                            </ul>
                        </div>
                        
                        <div className="flex justify-end gap-2">
                            <button
                                className="btn btn-primary"
                                onClick={() => updateStatus(roadmapData[currentItemIndex]._id)}
                            >
                                {roadmapData[currentItemIndex].status === "completed" ? "Mark as Incompleted" : "Mark as Completed"}
                            </button>
                            <button
                                className="btn"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}